module.exports = __webpack_public_path__ + "img/202412_flora_02.c1b36c69.jpg";